import { Outlet, useLocation } from 'react-router-dom'
import { useNotifications } from '../../hooks/notifications/useNotifications'
import { useUser } from '../../hooks/user/useUser'
import TabBar, { shouldHideTabBar } from '../../ui/layout/TabBar'
import ChallengeThemeProvider from '../theme/ChallengeThemeProvider'

export default function BaseLayout() {
  const { data: user } = useUser()
  const { unreadChatCount } = useNotifications()
  const { pathname } = useLocation()
  const showTabBar = !!user && !shouldHideTabBar(pathname)

  return (
    <ChallengeThemeProvider>
      <div
        style={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <main
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            maxWidth: 600,
            minHeight: 0,
            overflowY: 'auto',
            overscrollBehavior: 'contain',
            paddingBottom: showTabBar ? 0 : 'env(safe-area-inset-bottom)',
          }}
        >
          <Outlet />
        </main>
        {showTabBar && <TabBar unreadChatCount={unreadChatCount} />}
      </div>
    </ChallengeThemeProvider>
  )
}
